<template>
  <div>
    <div style="margin-bottom:15px;width:100%;display:flex">
      <div class="listSel MylistSel">
        <p>强生:</p>
        <van-dropdown-menu active-color="#CC4545" :overlay="false">
          <van-dropdown-item v-model="value" :options="hotSkuJnJlist" @change="changeType(value)" />
        </van-dropdown-menu>
      </div>
    </div>
    <div style="margin-bottom:15px;width:100%;display:flex">
      <div class="listSel2 MylistSel2">
        <p>{{CouCateGory1Sel==1?'竞店':CouCateGory1Sel==2?'竞品牌':'竞品'}}:</p>
        <van-dropdown-menu active-color="#CC4545" :overlay="false">
          <van-dropdown-item
            v-model="value2"
            :options="hotSkuMarketlist"
            @change="changeTop(value2)"
            class="right"
          />
        </van-dropdown-menu>
      </div>
    </div>

    <div class="TianCharts">
      <div id="myCharts"></div>
      <div class="Chart">
        <div>
          <span style="margin-right: 13px;font-size: 16px;color: #555555;">{{CouBrandSel}}同比</span>
           <el-icon :class="parseInt(JnJgrowth)>0?'el-icon-top-right listItemIcon':'el-icon-bottom-right listItemIcon'"></el-icon>
          <b style="font-size:18px">{{JnJgrowth}}</b>
        </div>|
        <div>
          <span
            style="margin-right: 13px;font-size: 16px;color: #555555;"
          >{{CouCateGory1Sel==1?'竞店':CouCateGory1Sel==2?'竞品牌':'竞品'}}同比</span>
          <el-icon :class="parseInt(Margrowth)>0?'el-icon-top-right listItemIcon':'el-icon-bottom-right listItemIcon'"></el-icon>
          <b style="font-size:18px">{{Margrowth}}</b>
        </div>
      </div>
    </div>
    <div class="industry_foot">
      <ul>
        <li>
          <van-row style="margin-top:8px">
            <van-col span="24" style="text-align:left">
              <h4>流量</h4>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{JnJvisitors}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{CouBrandSel}}</i>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{Marvisitors}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{this.CouCateGory1Sel==1?'竞店':this.CouCateGory1Sel==2?'竞品牌':'竞品'}}</i>
            </van-col>
          </van-row>
        </li>
        <li>
          <van-row style="margin-top:8px">
            <van-col span="24" style="text-align:left">
              <h4>转化</h4>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{JnJpaymentRate}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{CouBrandSel}}</i>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{MarpaymentRate}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{this.CouCateGory1Sel==1?'竞店':this.CouCateGory1Sel==2?'竞品牌':'竞品'}}</i>
            </van-col>
          </van-row>
        </li>
        <li>
          <van-row style="margin-top:8px">
            <van-col span="24" style="text-align:left">
              <h4>客单价</h4>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{parseInt(JnJunitPrice)}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{CouBrandSel}}</i>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <b>{{parseInt(MarunitPrice)}}</b>
            </van-col>
            <van-col span="6">
              <div style="opacity: 0;">1</div>
            </van-col>
          </van-row>
          <van-row style="margin-top:8px">
            <van-col span="12">
              <div style="opacity: 0;">1</div>
            </van-col>
            <van-col span="12">
              <i>/ {{this.CouCateGory1Sel==1?'竞店':this.CouCateGory1Sel==2?'竞品牌':'竞品'}}</i>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import pos from "../../../assets/jpg/pos.svg";
import lypos from "../../../assets/jpg/LyPos.png";
import qs from "qs";
import { mapState } from "vuex";

export default {
  data() {
    return {
      posData: [],
      MyxAxis: [],
      lyPos: [],
      maxLy: 0,
      value: "",
      value2: "",
      CouBrandSel: "",
      CouCateGory1Sel: 1,
      CouCateGory2Sel: 1,
      CoustartTime: "",
      CouendTime: "",
      JnJvisitors: "",
      JnJpaymentRate: "",
      JnJunitPrice: "",
      JnJgrowth: "",
      Margrowth: "",
      Marvisitors: "",
      MarpaymentRate: "",
      MarunitPrice: "",
      hotSkuJnJlist: [],
      hotSkuMarketlist: [],
    };
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myCharts"));
      myChart.on("click", function (params) {
        console.log(params);
      });
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function (a) {
            let list = [];
            let listItem = "";
            for (var i = 0; i < a.length; i++) {
              if (a[i].data < 1000) {
                listItem = parseInt(a[i].data);
              } else if (a[i].data >= 1000 && a[i].data < 1000000) {
                listItem = parseInt(a[i].data / 1000) + "K";
              } else if (a[i].data >= 1000000 && a[i].data < 100000000) {
                listItem = parseInt(a[i].data / 1000000) + "M";
              } else if (a[i].data >= 100000000 && a[i].data < 100000000000) {
                listItem = parseInt(a[i].data / 100000000) + "B";
              }
              list.push(a[i].seriesName + ":" + listItem + "</br>");
            }
            return list.toString().replace(/,/g, "");
          },
          height: 280,
          backgroundColor: " rgba(204, 69, 69,0.8);",
          padding: [5, 20, 10, 20], //边距
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF",
          },
        },
        legend: {
          show: true,
          top: "3.5%",
          right: "3.5%",
          itemWidth: 10,
          itemHeight: 10,
          icon: "circle",
          data: [
            { name: "强生GMV" },
            {
              name: `${
                this.CouCateGory1Sel == 1
                  ? "竞店GMV"
                  : this.CouCateGory1Sel == 2
                  ? "竞品牌GMV"
                  : "竞品GMV"
              }`,
            },
          ],
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        grid: {
          left: "10%",
          bottom: "30%",
        },
        xAxis: {
          show: true,
          type: "category",
          splitLine: { show: false },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center",
            },
          },
          axisLine: {
            lineStyle: {
              color: "white",
            },
          },
        },
        yAxis: [
          {
            show: true,
            type: "value",
            axisLabel: {
              formatter: function (value, index) {
                if (value < 1000) {
                  return value;
                } else if (value >= 1000 && value < 1000000) {
                  return value / 1000 + "K";
                } else if (value >= 1000000 && value < 1000000000) {
                  return value / 1000000 + "M";
                } else if (value >= 1000000000 && value < 1000000000000) {
                  return value / 1000000000 + "B";
                }
              },
              interval: 0,
              show: true,
              textStyle: {
                color: "#626262",
                fontSize: 10,
                letterSpacing: 0,
                fontFamily: "PingFangSC-Regular",
              },
            },
          },
        ],
        series: [
          {
            name: `${
              this.CouCateGory1Sel == 1
                ? "竞店GMV"
                : this.CouCateGory1Sel == 2
                ? "竞品牌GMV"
                : "竞品GMV"
            }`,
            type: "line",
            smooth: true,
            data: this.lypos,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "#5173B0", //折线颜色
              },
            },
          },
          {
            name: "强生GMV",
            type: "line",
            smooth: true,
            data: this.posData,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#23C8D8",
                areaStyle: { type: "default" },
                lineStyle: { color: "#23C8D8" },
              },
            },
            areaStyle: {
              // 实现蓝白渐变色
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#23C8D8",
                  },
                  {
                    offset: 1,
                    color: "#FFFFFF",
                  },
                ]),
              },
            },
          },
        ],
      });
    },
    getJnJchartsList() {
      this.$addr
        .post(
          "/radar/getMonthCompete",
          qs.stringify({
            storeType: "",
            competeType: this.CouCateGory1Sel,
            isMonthType: this.CoustartTime,
            yyyyMM: this.CouendTime,
            brand: this.CouBrandSel,
            cateGoryType: 1,
            jnjInfoName: this.value,
          })
        )
        .then((res) => {
          this.posData = [];
          // this.lypos = [];
          res.data.data.map((item, index) => {
            this.posData.push(parseFloat(item.transactionAmount));
            this.JnJvisitors = item.visitorsEn;
            this.JnJpaymentRate = item.paymentRate;
            this.JnJunitPrice = item.unitPrice;
            this.JnJgrowth = item.growth;
          });
          console.log(this.posData);
          this.drawLine();
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
    getMarketchartsList() {
      this.$addr
        .post(
          "/radar/getMonthCompete",
          qs.stringify({
            storeType: this.CouCateGory2Sel,
            competeType: this.CouCateGory1Sel,
            isMonthType: this.CoustartTime,
            yyyyMM: this.CouendTime,
            brand: this.CouBrandSel,
            cateGoryType: 0,
            infoName: this.value2,
          })
        )
        .then((res) => {
          this.lypos = [];
          this.MyxAxis = [];

          res.data.data.map((item, index) => {
            this.lypos.push(parseFloat(item.transactionAmount));
            this.Marvisitors = item.visitorsEn;
            this.MarpaymentRate = item.paymentRate;
            this.MarunitPrice = item.unitPrice;
            this.Margrowth = item.growth;
            this.MyxAxis.push(item.ymEn);
            this.MyxAxis = [...new Set(this.MyxAxis)];
          });
          this.drawLine();
        })
        .catch((error) => {
          this.$toast("接收数据中");
        });
    },
    getHotJnjSku() {
      this.$addr
        .post(
          "/radar/getCompeteName",
          qs.stringify({
            storeType: this.CouCateGory2Sel,
            competeType: this.CouCateGory1Sel,
            isMonthType: this.CoustartTime,
            yyyyMM: this.CouendTime,
            brand: this.CouBrandSel,
            cateGoryType: 1,
          })
        )
        .then((res) => {
          this.hotSkuJnJlist = [];
          res.data.data.map((item, index) => {
            this.value = item.jnjInfoName;
            this.hotSkuJnJlist.push({
              text: item.jnjInfoName,
              value: item.jnjInfoName,
            });
          });
          this.setThrGet();
        });
    },
    getHotMarketSku() {
      this.$addr
        .post(
          "/radar/getCompeteName",
          qs.stringify({
            storeType: this.CouCateGory2Sel,
            competeType: this.CouCateGory1Sel,
            isMonthType: this.CoustartTime,
            yyyyMM: this.CouendTime,
            brand: this.CouBrandSel,
            cateGoryType: 0,
          })
        )
        .then((res) => {
          this.hotSkuMarketlist = [];
          res.data.data.map((item, index) => {
            this.value2 = item.infoName;
            this.hotSkuMarketlist.push({
              text: item.infoName,
              value: item.infoName,
            });
          });
          this.setForGet();
        });
    },
    changeTop(value2) {
      this.getMarketchartsList();
    },
    changeType(value) {
      this.getJnJchartsList();
    },
  },
  computed: {
    ...mapState([
      "CoumonthFrom",
      "CoumonthTo",
      "CouBrand",
      "CouCateGory2",
      "CouCateGory1",
    ]),
  },
  watch: {
    CouCateGory2(currVal) {
      this.CouCateGory2Sel = currVal;
      this.setOneGet();
      this.setTwoGet();
      this.setThrGet();
      this.setForGet();
    },
    CoumonthFrom(currVal) {
      this.CoustartTime = currVal;
      this.setThrGet();
      this.setForGet();
    },
    CoumonthTo(currVal) {
      this.CouendTime = currVal;
      this.setThrGet();
      this.setForGet();
    },
    CouCateGory1(currVal) {
      this.CouCateGory1Sel = currVal;
      this.setOneGet();
      this.setTwoGet();
      this.setThrGet();
      this.setForGet();
    },
    CouBrand(currVal) {
      this.CouBrandSel = currVal;
      this.setOneGet();
      this.setTwoGet();
      this.setThrGet();
      this.setForGet();
    },
  },
  created() {
    let _ = require("lodash");
    this.setOneGet = _.debounce(this.getHotJnjSku, 500);
    this.setTwoGet = _.debounce(this.getHotMarketSku, 500);
    this.setThrGet = _.debounce(this.getJnJchartsList, 500);
    this.setForGet = _.debounce(this.getMarketchartsList, 500);
  },
};
</script>
<style scoped>
.listItemIcon {
  color: #fff;
  padding: 3px;
  border-radius: 50%;
  background: rgb(89, 91, 102);
  text-align: center;
  margin-right: 5px;
}
.Chart {
  position: absolute;
  height: 60px;
  width: 100%;
  background: #f6e7d4;
  border-radius: 0 0 20px 20px;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.industry_foot {
  margin-top: 10px;
  overflow: hidden;
  width: 100%;
}
.industry_foot h4 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #555555;
  letter-spacing: 0;
  line-height: 12px;
}
.industry_foot h5 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #5d5d5d;
  letter-spacing: 0;
  line-height: 12px;
}
.industry_foot h6 {
  font-family: "SourceHanSansCN-Normal";
  font-size: 12px;
  color: #5d5d5d;
  letter-spacing: 0;
  line-height: 12px;
}

.industry_foot b {
  font-family: "Arial-BoldMT";
  font-size: 18px;
  color: #555555;
  letter-spacing: 0;
  text-align: right;
  line-height: 18px;
}
.industry_foot ul {
  overflow-x: scroll;
  overflow-y: hidden;
  min-height: 180px;
  max-height: 180px;
  width: 100%;
  display: flex;
}
.industry_foot ul li {
  padding: 10px 10px 15px 10px;
  height: 97%;
  min-width: 25%;
  max-width: 25%;
  margin: 10px 7px 10px 10px;
  background: #faf1e7;
  box-shadow: 0 3px 20px 0 rgba(192, 168, 139, 0.7);
  border-radius: 20px;
}
.industry_foot ul li i {
  text-align: center;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  width: 100%;
  border-radius: 15px;
  font-family: "ArialMT";
  font-size: 10px;
  color: #555555;
  letter-spacing: 0;
}
.industry_footTop {
  background: #bce3a1;
}
.industry_footBot {
  background-color: #efc2bf;
}
.industry_footAct {
  position: relative;
  background-color: #f6e7d4 !important;
  border: 3px solid #d9b17e;
  box-shadow: 0 5px 25px 0 rgba(122, 81, 32, 0.3);
}
.TianCharts {
  position: relative;
}
#myCharts {
  min-height: 360px;
  /* margin-bottom: 20px; */
  background: #faf1e7;
  box-shadow: 0 5px 20px 0 rgba(175, 151, 123, 0.5);
  border-radius: 25px;
}
#rate {
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 280px;
  margin-bottom: 20px;
}
.listSel2,
.listSel {
  width: 100%;
  display: flex;
  align-items: center;
  font-family: "SourceHanSansCN-Normal";
  font-size: 14px;
  color: #555555;
  letter-spacing: 0;
  line-height: 14px;
}

.MylistSel2 .van-dropdown-menu {
  width: 60% !important;
}
.MylistSel .van-dropdown-menu {
  width: 60% !important;
}

.listSel2 .van-dropdown-menu {
  z-index: 7;
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}

.listSel .van-dropdown-menu {
  background: #f9f6f2;
  border: 1px solid #555555;
  border-radius: 15px;
  box-shadow: 0 3px 8px 0 rgba(204, 69, 69, 0.3);
  width: 40%;
  height: 20px;
  position: relative;
  left: 10px;
}
.listSel .van-dropdown-menu /deep/ .van-popup--top {
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  width: 60%;
   left: 10.5% !important;
}

.listSel2 .van-dropdown-menu /deep/ .van-popup--top {
  background: rgba(175, 151, 123, 0.9);
  border-radius: 5%;
  top: 4px;
  width: 60%;
  left: 10.5% !important;
}
/deep/ .van-cell__value {
  display: none;
}
/deep/ .van-cell__title {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #ffffff;
}
/deep/ .van-cell {
  background-color: rgba(0, 0, 0, 0);
}
/deep/ .van-ellipsis {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #555555;
}
/deep/ .van-dropdown-menu__title::after {
  text-align: right;
  border-color: transparent transparent #555555 #555555;
}
/deep/ .van-dropdown-item__content {
  max-height: 55%;
}
</style>


// WEBPACK FOOTER //
// src/components/ButFo_Radar/public/CompeteMap.vue